import React, { Component, createRef } from 'react';
import Header from '../components/Principal/Header';
import Footer from '../components/Principal/Footer';
import MensajeF from '../components/Mensaje_Flotante/MensajeF';
import Seccion01 from '../components/EstrategiasComerciales/CooperaGanaMas/Seccion01';
import Seccion02 from '../components/EstrategiasComerciales/CooperaGanaMas/Seccion02';
import Seccion03 from '../components/EstrategiasComerciales/CooperaGanaMas/Seccion03';
import Seccion04 from '../components/EstrategiasComerciales/CooperaGanaMas/Seccion04';
import Seccion05 from '../components/EstrategiasComerciales/CooperaGanaMas/Seccion05';

class EstComCooperaGanaMas extends Component {
    constructor(props) {
        super(props);
        this.state = { showOverlay: false, puntos: '', showOverlay: false }

        this.seccion02Ref = createRef();
        this.seccion03Ref = createRef();
        this.seccion04Ref = createRef();
        this.seccion05Ref = createRef();
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    scrollToSection = (sectionId) => {
        if (sectionId === 2 && this.seccion02Ref.current) {
            this.seccion02Ref.current.scrollIntoView({ behavior: 'smooth' });
        } else if (sectionId === 3 && this.seccion03Ref.current) {
            this.seccion03Ref.current.scrollIntoView({ behavior: 'smooth' });
        } else if (sectionId === 4 && this.seccion04Ref.current) {
            this.seccion04Ref.current.scrollIntoView({ behavior: 'smooth' });
        } else if (sectionId === 5 && this.seccion05Ref.current) {
            this.seccion05Ref.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    mostrarTienda = (mostrar) => {
        this.setState({ showOverlay: mostrar, showOverlay: mostrar });
    }

    render() {
        return (
            <>
                <Header id={2} />
                <div style={{ paddingTop: '118px' }}>
                    <Seccion01 onButtonClick={this.scrollToSection} mostrarOnClick={this.mostrarTienda} showOverlay={this.state.showOverlay} />
                </div>
                {!this.state.showOverlay ? (
                    <>
                        <div ref={this.seccion02Ref}>
                            <Seccion02 />
                        </div>

                        <div ref={this.seccion03Ref}>
                            <Seccion03 />
                        </div>

                        <div ref={this.seccion04Ref}>
                            <Seccion04 mostrarClick={this.mostrarTienda} scrollClick={this.scrollToSection} />
                        </div>

                        <div ref={this.seccion05Ref}>
                            <Seccion05 />
                        </div>
                    </>
                ):(<></>)}
                <MensajeF />
                <Footer />
            </>
        );
    }
}

export default EstComCooperaGanaMas;